import {
	CreateTaskRequest,
	CreateTaskResponse,
	PasswordResetRequest,
	PasswordResetResponse,
	StatusUpdateRequest,
	StatusUpdateResponse,
	TaskDetails,
	TaskResponse,
	UpdateTaskRequest,
} from '../@types';
import axiosInstance from './axios-instance';
import { Task, Page } from '../@types';
import { handleError } from './utils';

/**
 * Creates a task
 */
export const createTask = (data: {task: CreateTaskRequest, investigationId: string}) =>
	axiosInstance.post<any>('/task/createTask/', data).catch(handleError);

/**
 * Creates a task
 */
 export const createTaskResponse = (data: CreateTaskResponse) =>
 axiosInstance.post<any>('/task/createResponse/', data).catch(handleError);


/**
 * Gets a task by id
 */
export const getTask = (taskID: string) =>
	axiosInstance
		.get<TaskDetails>('/task/gettask/id', {
			params: { id: taskID },
		})
		.catch(handleError);

/**
 * Gets a response by id
 */
 export const getResponse = (responseID: string) =>
 axiosInstance
	 .get<TaskResponse>('/task/getResponse/id', {
		 params: { id: responseID },
	 })
	 .catch(handleError);


/**
 * Gets a page of tasks
 */
export const getTasks = () =>
	axiosInstance.get<TaskDetails[]>(`/task/getalltasks/`).catch(handleError);

/**
 * Updates a task's status
 */
export const updateTaskById = (task: UpdateTaskRequest) =>
	axiosInstance
		.put<UpdateTaskRequest>('/task/updateTask', task)
		.catch(handleError);

/**
 * Deletes a task by id
 */
export const deleteTask = (id: string) =>
	axiosInstance
		.delete('/task/deleteTaskById', { data: { id: id } })
		.catch(handleError);
